import React, { useState, useEffect, useRef } from 'react';
import './TextAreaInput.css';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';

export default function TextAreaInput({ initialValue, rules, name, onValidate, label, subLabel, instructions, showError, errorMessage, disabled, placeholder }) {
  const [value, setValue] = useState(initialValue ? initialValue : '');
  const [validationDetails, setValidationDetails] = useState(null);
  const [isValid, setIsValid] = useState(null);
  const [textLength, setTextLength] = useState(0);
  const nativeRef = useRef(null);
  const setNativeRef = el => { nativeRef.current = el; }

  if (logComponent('TextAreaInput')) { console.debug('TextAreaInput rendered'); }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('TextAreaInput')) { console.debug('TextAreaInput onMount'); }
    validateThis();
  }, [])

  const updateValue = (e) => {
    if (logComponent('TextAreaInput')) { console.debug('TextAreaInput updateValue'); }
    setValue(e.target.value);
    setTextLength(e.target.value.length);
  }

  const validateThis = () => {
    if (logComponent('TextAreaInput')) { console.debug('TextAreaInput validateThis'); }

    let validationDetailsThis = [];
    for (let rule in rules) {
      validationDetailsThis.push({
        rule: rule,
        valid: validate[rule](value, rules[rule])
      })
    }

    let isValidThis = validationDetailsThis.reduce((prev, curr) => prev && curr.valid, true);
    setValidationDetails(validationDetailsThis);
    setIsValid(isValidThis);

    onValidate({
      name: name,
      isValid: isValidThis,
      value: value
    });
  }

  const focus = () => {
    if (logComponent('TextAreaInput')) { console.debug('TextAreaInput focus'); }
    nativeRef.current.focus();
  }

  const onKeyDown = () => {
    if (logComponent('TextAreaInput')) { console.debug('TextAreaInput onKeyDown'); }
    //TODO:  What to put here.  Method was missing
  }

  return (
    <div className="Text-Area-Input">
      {
        showError && !isValid &&
        <p className="Text-Area-Input__error">{errorMessage}</p>
      }
      <label
        className="Text-Area-Input__label"
        htmlFor={name + '-input'}>
        {label}
        {
          rules && rules.required &&
          <span className="Text-Area-Input__required"> *</span>
        }
      </label>
      {
        subLabel &&
        <p className="Text-Area-Input__sub-label">{subLabel}</p>
      }
      <div className="Text-Area-Input__body">
        <textarea
          id={name + 'input'}
          className="Text-Area-Input__textarea"
          spellCheck="false"
          value={value}
          placeholder={placeholder}
          onChange={updateValue}
          onBlur={validateThis}
          onKeyUp={validateThis}
          onKeyDown={onKeyDown}
          ref={setNativeRef}
          readOnly={disabled} />
        {
          rules.maxLength &&
          <div className={'Text-Area-Input__word-count' + (rules.maxLength && textLength > rules.maxLength ? ' Text-Area-Input__word-count--warning' : '')}>{textLength}/{rules.maxLength}</div>
        }
      </div>
      {
        instructions &&
        <span className="Text-Area-Input__instructions">{instructions}</span>
      }
    </div>
  );
}